module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-menu-bar"
  }, [(_vm.isFTBStyleApplied && _vm.isLoggedIn) ? _c('div', {
    staticClass: "right-shadow"
  }) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "main-menu-bar__logo",
    attrs: {
      "to": _vm.getMainPage(),
      "title": _vm.$t('generic.application_name'),
      "alt": _vm.$t('generic.application_name')
    }
  }), _vm._v(" "), (_vm.getCurrentSession.state === 'ready' && _vm.getCurrentSession.data.user) ? _c('nav', [_c('ul', {
    staticClass: "main-menu-bar__menu"
  }, [(_vm.showSidemenu) ? _c('li', {
    staticClass: "main-menu-bar__menu__list-item main-menu-bar__menu__list-item--toggle-menu"
  }, [_c('a', {
    class: ['main-menu-bar__menu__list-item__link', {
      'active': _vm.isSubmenuActive
    }],
    attrs: {
      "href": "#!",
      "title": _vm.$t('generic.mainmenu.submenu'),
      "alt": _vm.$t('generic.mainmenu.submenu')
    },
    on: {
      "click": function($event) {
        _vm.toggleSubMenu()
      }
    }
  }, [_c('span'), _vm._v("\n                        " + _vm._s(_vm.$t('generic.mainmenu.submenu')) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _vm._l((Object.values(_vm.mainMenu)), function(mainMenuItem) {
    return _c('li', {
      key: mainMenuItem.name,
      staticClass: "main-menu-bar__menu__list-item"
    }, [(mainMenuItem.visible) ? _c('router-link', {
      staticClass: "main-menu-bar__menu__list-item__link",
      attrs: {
        "to": {
          name: mainMenuItem.name
        }
      }
    }, [_c('i', {
      staticClass: "main-menu-bar__menu__list-item__link__icon",
      class: mainMenuItem.meta.icon
    }), _vm._v(" " + _vm._s(mainMenuItem.meta.title) + "\n                    ")]) : _vm._e()], 1)
  }), _vm._v(" "), _c('li', {
    staticClass: "main-menu-bar__menu__list-item hide-desktop"
  }, [(_vm.getCurrentSession.state === 'ready' && _vm.getCurrentSession.data.user) ? _c('dq-usermenu', {
    attrs: {
      "label": _vm.getCurrentSession.data.user.name,
      "showLogout": true
    }
  }) : _vm._e()], 1)], 2)]) : _vm._e()], 1), _vm._v(" "), (_vm.getCurrentSession.state === 'ready' &&
    _vm.getCurrentSession.data.user && _vm.showSidemenu) ? _c('div', {
    class: ['sub-menu-bar', {
      'open': _vm.isOpenActive
    }, {
      'sub-menu-bar__ftb-menu-padding': _vm.isFTBStyleApplied
    }]
  }, [_c('div', {
    staticClass: "right-shadow-sub-menu"
  }), _vm._v(" "), (_vm.$route.meta.sidemenu) ? _c('nav', [(_vm.$route.meta.sidemenu) ? _c('ul', {
    class: ['sub-menu-bar__menu', {
      'ftb-sub-menu-margin': _vm.isFTBStyleApplied
    }]
  }, [(_vm.isFTBStyleApplied) ? _c('img', {
    staticClass: "right-shadow-sub-menu__ftb-logo",
    attrs: {
      "src": _vm.ftbLogo,
      "alt": "ftb-logo"
    }
  }) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('generic.submenu.title')) + " "), _c('a', {
    staticClass: "reset__Link",
    on: {
      "click": _vm.resetSubMenu
    }
  }, [_vm._v(_vm._s(_vm.$t('generic.submenu.reset_text')))])]), _vm._v(" "), _c('el-menu', {
    attrs: {
      "default-active": "2",
      "unique-opened": true
    },
    on: {
      "open": _vm.handleMenu,
      "close": _vm.handleMenu
    }
  }, [_c('dq-sidemenu', {
    attrs: {
      "model": _vm.getOrganizationSimpleTree
    }
  })], 1)], 1) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "loggedin-userinfo"
  }, [(_vm.isLoggedIn) ? _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'logout'
      },
      "title": _vm.$t('generic.logout.buttons.logout'),
      "alt": _vm.$t('generic.logout.buttons.logout')
    }
  }, [_vm._v(_vm._s(_vm.$t('generic.logout.buttons.logout')) + "\n            "), _c('i', {
    staticClass: "ion-ios-locked-outline"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('dq-usermenu', {
    attrs: {
      "label": _vm.getCurrentSession.data.user.name
    }
  }) : _vm._e(), _vm._v(" "), _c('el-dropdown', {
    class: [_vm.isLoggedIn ? '' : 'el-lang'],
    attrs: {
      "trigger": "click",
      "menu-align": "start"
    },
    on: {
      "command": _vm.changeLanguage
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('span', {
    staticClass: "flag-icon",
    class: _vm.getFlagClass(_vm.currentLanguage)
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "el-dropdown-languages",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "en"
    }
  }, [_c('span', {
    staticClass: "flag-icon",
    class: [_vm.isFTBStyleApplied ? 'flag-icon-us' : 'flag-icon-en']
  })]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "nl"
    }
  }, [_c('span', {
    staticClass: "flag-icon flag-icon-nl"
  })]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "fr"
    }
  }, [_c('span', {
    staticClass: "flag-icon flag-icon-fr"
  })]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "de"
    }
  }, [_c('span', {
    staticClass: "flag-icon flag-icon-de"
  })]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "sk"
    }
  }, [_c('span', {
    staticClass: "flag-icon flag-icon-sk"
  })]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "pl"
    }
  }, [_c('span', {
    staticClass: "flag-icon flag-icon-pl"
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "el-dropdown"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogTryNewPortal = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('generic.new_portal.title')))])], 1)], 1), _vm._v(" "), _c('div', {
    class: ['main-content', {
      'open': _vm.isOpenActive
    }]
  }, [_c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "copy-right"
  }, [_c('div', [_vm._v(" © " + _vm._s(_vm.currentYear) + " " + _vm._s(_vm.buildProp.name) + " v" + _vm._s(_vm.buildProp.version) + " - " + _vm._s(_vm.$t('generic.copy_right')) + " ")])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('generic.new_portal.title'),
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogTryNewPortal),
      callback: function($$v) {
        _vm.dialogTryNewPortal = $$v
      },
      expression: "dialogTryNewPortal"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('generic.new_portal.dialog.description_1'))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogTryNewPortal = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('generic.overview.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.navigateToNewPortal
    }
  }, [_vm._v(_vm._s(_vm.$t('generic.new_portal.dialog.confirm')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-25441132!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 489
// module chunks = 36